import blitzMessage, { EVENTS } from "@/__main__/ipc-core.mjs";
import ANALYTIC_EVENTS from "@/feature-analytics/analytic-events.mjs";
import { refs__PRIVATE as refs } from "@/feature-analytics/tracker.mjs";

let interval = null;
const window_state = {};
let initial = false;
const reportWindow = (created, data) => {
  const event_data = {
    name: data.name,
    might_been_started_before_blitz: data.might_hbr,
    duration: data.duration,
    time: Date.now(),
  };

  let isAnonymous = true;
  if (data.name === "Grand Theft Auto V") {
    isAnonymous = false;
  }

  const event_name = created
    ? ANALYTIC_EVENTS.GAME_START
    : ANALYTIC_EVENTS.GAME_EXIT;
  refs.trackEvent(event_name, event_data, isAnonymous);
};
const run = async () => {
  const filtered = await blitzMessage(EVENTS.GET_OPEN_WINDOWS);
  if (!filtered) return;
  const removedKeys = Object.keys(window_state).filter(
    (key) => !filtered.find((entry) => entry.name === key),
  );
  for (const k of removedKeys) {
    const entry = window_state[k];
    if (entry.reported_start) {
      if (!entry.might_hbr) entry.duration = Date.now() - entry.start;
      reportWindow(false, entry);
    }
    delete window_state[k];
  }
  for (const entry of filtered) {
    const existing = window_state[entry.name];
    if (existing) {
      window_state[entry.name] = { ...existing, ...entry };
      continue;
    }
    const o = {
      ...entry,
      start: Date.now(),
      reported_start: true,
      might_hbr: !initial,
    };
    reportWindow(true, o);

    window_state[o.name] = o;
  }
  initial = true;
};
const iteration = () => {
  interval = setTimeout(
    () => {
      run();
      iteration();
    },
    1000 * 60 * 2.5,
  );
};
export const start = () => {
  if (interval) return;
  iteration();
  run();
};

export const stop = () => {
  if (!interval) return;
  clearTimeout(interval);
  interval = null;
  for (const k in window_state) delete window_state[k];
  initial = false;
};
